export default {
    link: {
        color: '#7f7f7f'
    },
    boldLink: {
        color: '#7f7f7f !important',
        fontWeight: 'bold'
    },
    savedCardHeader: {
        background: '#fcd21d !important'
    },
    savedCard: {
        background: '#eee'
    }
};
